{
  "name": "buzon-digital",
  "version": "0.0.0",
  "scripts": {
    "ng": "ng",
    "start": "ng s",
    "start:open": "ng s -o",
    "start:cert": "ng s -c certification",
    "start:prod": "ng s -c production",
    "build:dev": "ng b",
    "build:cert": "ng b -c certification",
    "build:prod": "ng b -c production",
    "lint": "ng lint",
    "lint:fix": "ng lint --fix",
    "clean": "rimraf node_modules .angular",
    "ci": "run-p build:*"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^17.3.9",
    "@angular/cdk": "^17.3.9",
    "@angular/common": "^17.3.9",
    "@angular/compiler": "^17.3.9",
    "@angular/core": "^17.3.9",
    "@angular/forms": "^17.3.9",
    "@angular/platform-browser": "^17.3.9",
    "@angular/platform-browser-dynamic": "^17.3.9",
    "@angular/router": "^17.3.9",
    "@ng-bootstrap/ng-bootstrap": "^16.0.0",
    "@ng-select/ng-select": "^12.0.6",
    "@ngneat/cashew": "^3.1.0",
    "@ngneat/overview": "^6.0.0",
    "@ngx-translate/core": "^15.0.0",
    "@ngx-translate/http-loader": "^8.0.0",
    "@ngxpert/hot-toast": "^2.0.0",
    "@popperjs/core": "^2.11.8",
    "chart.js": "^4.4.1",
    "crypto-js": "^4.1.1",
    "ng-recaptcha": "^13.2.1",
    "ng2-charts": "^5.0.4",
    "ngx-mask": "^17.0.4",
    "rxjs": "~7.8.0",
    "tslib": "^2.6.2",
    "zone.js": "~0.14.3"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "^17.3.9",
    "@angular-eslint/builder": "17.2.1",
    "@angular-eslint/eslint-plugin": "17.2.1",
    "@angular-eslint/eslint-plugin-template": "17.2.1",
    "@angular-eslint/schematics": "17.2.1",
    "@angular-eslint/template-parser": "17.2.1",
    "@angular/cli": "~17.3.9",
    "@angular/compiler-cli": "^17.3.9",
    "@angular/localize": "^17.3.9",
    "@types/crypto-js": "^4.1.2",
    "@typescript-eslint/eslint-plugin": "6.19.0",
    "@typescript-eslint/parser": "6.19.0",
    "eslint": "^8.56.0",
    "npm-run-all": "^4.1.5",
    "prettier": "^3.2.4",
    "rimraf": "^5.0.5",
    "typescript": "~5.3.3"
  }
}
